module.exports = __webpack_public_path__ + "img/Logo-White-Header.792fa868.png";